const SliderTooltip = ({ children, theme = {} }) => {

    const themeTooltipBlock = {
        position: "absolute",
        bottom: "100%",
        left: "50%",
        transform: "translate(-50%, -15px)",
        userSelect:'none',
        pointerEvents: 'none'
    }

    const themeTooltipSpan = {
        color: "#ffffff",
        whiteSpace: "nowrap",
        padding: '3px',
        backgroundColor: 'var(--bs-dark)',
        display: 'inline-block'
    }


    return (
        <div style={themeTooltipBlock}>
            <span style={themeTooltipSpan}>
                {children}
            </span>
        </div>
    );
};

export default SliderTooltip;
